import { render, staticRenderFns } from "./PropGrossEstimate.vue?vue&type=template&id=1de3a24a&scoped=true&"
import script from "./PropGrossEstimate.vue?vue&type=script&lang=js&"
export * from "./PropGrossEstimate.vue?vue&type=script&lang=js&"
import style0 from "./PropGrossEstimate.vue?vue&type=style&index=0&id=1de3a24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3a24a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDivider,VRow})
